import axios from "axios";
import {LocalStorage} from "./storage";

axios.interceptors.request.use((req) => {
  const token = LocalStorage.get(LocalStorage.token);
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

export default axios;
